export default __webpack_public_path__ + "static/media/VehicleHealth_Green.5f9ad162.png";